/**
 * =============================================================================
 * FUENTE UNICA DE LOS PUNTOS DE RUPTURA DEL PORTAL REVI
 * =============================================================================
 * Son los de Ant Design, no una escala propia, y el motivo no es estetico: el
 * <Sider> que rompe el movil resuelve su breakpoint contra estos numeros
 * (dimensionMaxMap en antd/es/layout/Sider.js), y las <Col xs=...> que ya hay
 * repartidas por el portal, tambien. Inventar una escala paralela significaria
 * que el CSS y el JS discrepan justo en las franjas intermedias.
 *
 * OJO: el `lg` de Tailwind es 1024, no 992. Nunca digas "lg" sin decir de que
 * sistema. Aqui, y en _breakpoints.scss, lg es 992.
 * =============================================================================
 */

export const BREAKPOINTS = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600,
};

// Los maximos que usa antd internamente. El 0,02 evita que un viewport de
// exactamente 992 px caiga en los dos lados a la vez.
export const BREAKPOINTS_MAX = {
  xs: 575.98,
  sm: 767.98,
  md: 991.98,
  lg: 1199.98,
  xl: 1599.98,
};

/**
 * Las dos fronteras del portal, con nombre de negocio en vez de nombre de talla.
 *
 * SHELL  (< 992): el menu deja de ser una columna y pasa a ser un cajon.
 * PAGINA (< 768): el contenido de cada pagina se reorganiza en una columna.
 */
export const FRONTERA_SHELL = BREAKPOINTS_MAX.md; // 991.98
export const FRONTERA_PAGINA = BREAKPOINTS_MAX.sm; // 767.98

export const CONSULTA_SHELL = `(max-width: ${FRONTERA_SHELL}px)`;
export const CONSULTA_PAGINA = `(max-width: ${FRONTERA_PAGINA}px)`;
